import "./SingleTeamMemberTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleTeamMemberTemplateSection from "./sections/SingleTeamMemberTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleTeamMemberTemplatePage() {

  return (
    <div>
      <Header />
      <SingleTeamMemberTemplateSection />
      <Footer />
    </div>
  )
}
